import { Field } from 'formik';
import React, { FC, useMemo } from 'react';
import { Card, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import CustomTooltip from '../../../../components/CustomTooltip/CustomTooltip';
import { getAvailableCountries } from '../../../../global/countries/countries';
import { statesByCountries } from '../../../../global/countries/states';
import styles from './VendorProfileTradingAddress.module.scss';

interface Props {
  selectedCountry: string;
}

const VendorProfileTradingAddress: FC<Props> = ({ selectedCountry }: Props) => {
  const countries = useMemo(() => getAvailableCountries(), []);
  const states = statesByCountries[selectedCountry];
  return (
    <Card className="h-lg-100 mb-3 p-3">
      <h4 className="sss-form-title">
        Trading Address <span className="sss-color-orange small">(enter if different)</span>{' '}
        <CustomTooltip innerClassName={styles.VendorProfileTradingAddress__tooltip}>
          Only required if your trading address is different from your registered address
        </CustomTooltip>
      </h4>
      <Row className="d-flex justify-content-between">
        <Col lg={12}>
          <FormGroup>
            <Label className="sss-form-subtitle">
              Address Line 1 <span className="sss-color-orange">*</span>
            </Label>
            <Field as={Input} name="tradingAddress1" type="text" />
          </FormGroup>
        </Col>
        <Col lg={12}>
          <FormGroup>
            <Label className="sss-form-subtitle">Address Line 2</Label>
            <Field as={Input} name="tradingAddress2" type="text" />
          </FormGroup>
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col lg={6}>
          <FormGroup>
            <Label className="sss-form-subtitle">
              City <span className="sss-color-orange">*</span>
            </Label>
            <Field as={Input} name="tradingCity" type="text" />
          </FormGroup>
        </Col>
        <Col lg={6}>
          <FormGroup>
            <Label className="sss-form-subtitle">
              Zip Code or Postcode <span className="sss-color-orange">*</span>
            </Label>
            <Field as={Input} name="tradingPostCode" type="text" />
          </FormGroup>
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col lg={6}>
          <FormGroup>
            <Label className="sss-form-subtitle">
              Country <span className="sss-color-orange">*</span>
            </Label>
            <Field as={Input} name="tradingCountry" type="select">
              {countries.map((country) => (
                <option key={country.abbr} value={country.abbr}>
                  {country.title}
                </option>
              ))}
            </Field>
          </FormGroup>
        </Col>
        <Col lg={6}>
          {states && (
            <FormGroup>
              <Label className="sss-form-subtitle">
                State <span className="sss-color-orange">*</span>
              </Label>
              <Field as={Input} disabled={!states} name="tradingState" type="select">
                {states.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </Field>
            </FormGroup>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default VendorProfileTradingAddress;
